<template>
    <header class="header">
        <div class="wrap">
            <div class="logo"></div>
            <div class="nav">
                <el-menu
                    active-text-color="#ffcc00"
                    background-color="#0b4a68"
                    text-color="#fff"
                    mode="horizontal"
                    :default-active="activeIndex"
                    >            
                    <el-menu-item
                            v-for="item in noChildren"
                            :index="item.name"                        
                            :key="item.path"
                            class="menu-item"
                            @click="clickMenu(item)">
                        {{item.label}}
                    </el-menu-item>
                </el-menu>
                
            </div>
            <div class="tpright">
                <div class="tpitem tpsign" @click="toSign">签到赠点</div>
                <template v-if="$store.state.userInfo">
                    <div class="tpitem tpuser">
                        <template v-if="userInfo">欢迎, <span class="tpusname">{{ userInfo.name }}</span></template>
                        <div class="tpusermenu">
                            <template v-if="userInfo">剩余<span class="tpuspoint">{{ userInfo.gold }}</span>点</template>
                            <div><a @click="$router.push('/subscribe')">我的订阅</a></div>
                            <div><a @click="$router.push('/cost')">我的交易</a></div>
                            <div><a @click="$router.push('/recharge')">账户充值</a></div>
                            <div><a @click="$router.push('/account')">资料安全</a></div>
                            <div @click="exit">退出</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="tpitem lg" @click="tologin">登录</div>
                    <div class="tpitem lg rg" @click="toreg"><span>注册</span></div>
                </template>
            </div>
            <div class="navbg"></div>
        </div>
    </header>

    <login v-if="dialogLoginVisible" @cancel="loginCancel" @confirm="loginConfirm"></login>
    <register v-if="dialogRegVisible" @cancel="regCancel" @confirm="regConfirm"></register>
    
</template>

<script>
    import yzcode from '@/components/yzcode'
    import login from '@/components/login'
    import register from '@/components/register'
    export default {
        components: {
          yzcode, login, register
        },
        name: "header",
        computed: {
            //没有子菜单
            noChildren() {
                return this.menuList.filter(item => !item.children)
            },
            //有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
            hasChildren() {
                return this.menuList.filter(item => item.children)
            },
        },
        watch: {
            '$route': {
                handler (router) {
                    this.getCurrentNav(router)
                }
            },
            '$store.state.userInfo': {
                handler (userInfo) {
                    // console.log(userInfo)
                    this.userInfo = userInfo
                }
            },
            '$store.state.token': {
                handler (token) {
                    // console.log(token)
                    // 在你的组件内
                    // this.$router.replace({ name: this.$route.name, params: { t: Date.now() } });
                    // console.log('token', token)
                    if(token === '' || token === undefined){
                        this.$router.replace({ name: 'free'})
                        // this.$router.push('/')
                    }
                }
            }
        },
        mounted(){
            this.getCurrentNav(this.$route)

            let BreadList = []
            this.menuList.forEach(c=>{
                // console.log(c)
                if(c.children){
                    let label_parent = c.label
                    c.children.forEach(k=>{
                        BreadList.push([{label: label_parent}, {label: k.label, name: k.name}])
                    })
                }
                else{
                    BreadList.push([{label: c.label, name: c.name}])
                }
            })
            this.$store.commit('setBreadList', BreadList)

            this.userInfo = this.$store.state.userInfo

            this.checkAccount()
        },
        data(){
            return {
                userInfo: {},

                dialogLoginVisible: false,
                
                dialogRegVisible: false,

                activeIndex: 'home',
                menuList:[
                    {
                        path: '/',
                        name: 'home',
                        label: '首页',
                    },
                    {
                        path: '/free',
                        name: 'free',
                        label: '免费分析',
                    },
                    {
                        path: '/expert',
                        name: 'expert',
                        label: '专家分析',
                    },
                    {
                        path: '/help',
                        name: 'help',
                        label: '帮助中心',
                    },
                    // {
                    //     path: '/fenxi',
                    //     name: 'fenxi',
                    //     label: '赛事分析',
                    // },
                    {
                        // path: '/odds',
                        name: 'odds',
                        label: '比分赔率',
                    },
                ]
            }
        },
        methods: {
            //跳转路由 根据名称跳转
            clickMenu(item) {
                // console.log(item)
                if(item.name === 'odds'){
                    window.open('http://www.s78999.com/','_blank')
                    return
                }
                this.$store.commit('selectMenu', item)
                this.$router.push({ name: item.name })
                // this.$router.replace({ name: item.name })
            },
            getCurrentNav(route){
                let that = this
                // console.log(route)
                let route_name = route.name
                // console.log(route_name)
                let menu1 = this.menuList.filter(item => !item.children)
                let menu2 = this.menuList.filter(item => item.children)
                let menu_n = []
                menu2.forEach(c=>{
                    c.children.forEach(k=>{
                        menu1.push(k)
                    })                    
                })
                that.activeIndex = ''
                menu1.forEach(c=>{
                    if(c.name === route_name)
                        that.activeIndex = c.name
                })
            },

            toreg(){
                this.dialogRegVisible = true
            },
            regCancel(){
                this.dialogRegVisible = false
            },
            regConfirm(){
                this.dialogRegVisible = false
                this.tologin()
            },
            
            tologin(){
                this.dialogLoginVisible = true                
            },
            loginCancel(){
                this.dialogLoginVisible = false
            },
            loginConfirm(){
                this.dialogLoginVisible = false
                // this.$router.replace({ name: 'free'})
            },

            toSign(){
                let that = this
                if(that.$store.getters.isLogin){
                    // let sign = that.$store.state.userInfo.sign
                    // if(sign !== 1){
                        that.$http.post('common/sign', {}, true).then(res=>{
                            if(res){
                                this.$store.commit('SIGNIN', res.data.blance)
                                that.$tpSuccess(res.msg)
                            }
                        })
                    // }else{
                    //     that.$tpToast('今日已签到')
                    // }
                }else{
                    that.tologin()
                }
            },
            exit(){
                this.$tpConfirm('确定退出登录？',(close) => {
                    close()
                    this.$store.commit('EXIT')
                })                
            },

            checkAccount(){
                let that = this
                that.$http.post('loginCheck').then(res=>{
                    if(res){
                        if(res.data && res.data.state === 1){
                            that.$store.commit('EXIT')
                        }
                    }
                })
            }

        }
    }
</script>

<style scoped>
.dgbtmak{float:left;font-size:12px;color:#999;line-height: 30px;}
.dgbtmak span{cursor: pointer;font-size:12px;}
.tips{font-size:12px;color:#666;line-height: 22px;color:#f90;}
</style>
